import React from "react";

const TodoBanner = () => {
  return (
    <>
      <div className="todolist__instruction">
        <p>Drag and drop to reorder list</p>
      </div>
    </>
  );
};

export default TodoBanner;
